import { Action, combineReducers, createFeatureSelector } from '@ngrx/store';

import * as fromScreen from './screen/screen.reducer';
import * as fromToast from './toast/toast.reducer';
import * as fromBackButton from './back-button/back-button.reducer';

export const feature = 'ui';

export interface State {
  screen: fromScreen.State;
  toast: fromToast.State;
  backButton: fromBackButton.State
}

export function reducer(state: State | undefined, action: Action) {
  return combineReducers({
    screen: fromScreen.reducer,
    toast: fromToast.reducer,
    backButton: fromBackButton.reducer
  })(state, action);
}

export const selectState = createFeatureSelector<State>(feature);

export const getScreen = (state: State) => state.screen;
export const getToast = (state: State) => state.toast;
export const getBackButton = (state: State) => state.backButton;
